window.site = (window.site || {});

/**
 * Init script
 * @class Site
 * @static
 */
site.MobileNav = (function MobileNav() {

  'use strict';

  /**
   * Has the class been initialized?
   * @private
   */
  let inited = false;

  /**
   * Initializes the class.
   * @public
   */
  const init = function () {

    // Abort if already initialized
    if (inited) {
      return false;
    }

    inited = true;

    var direction = '';
    var last_known_scroll_position = 0;
    var ticking = false;

    function checkScrollPos(scroll_pos) {
      document.querySelector('html').setAttribute('data-direction', direction);

      if (scroll_pos >= 155) {
        document.querySelector('body').classList.add('hide-nav');
      } else {
        document.querySelector('body').classList.remove('hide-nav');
      }
    }

    document.addEventListener('scroll', function(e) {
      if (last_known_scroll_position < window.scrollY) {
        direction = 'down';
      } else if (last_known_scroll_position > window.scrollY + 25) {
        direction = 'up';
      }

      last_known_scroll_position = window.scrollY;

      if (!ticking) {
        window.requestAnimationFrame(function() {
          checkScrollPos(last_known_scroll_position);
          ticking = false;
        });

        ticking = true;
      }
    });

    if (!document.querySelector('.navigation-close')) { return; };

    // Mobile Menu
    document.querySelector('.mobile-menu-trigger').addEventListener('click', function(e) {
      e.preventDefault();
      document.querySelector('.navigation-mobile').classList.add('is-active');
      document.querySelector('.navigation-mobile-overlay').classList.add('is-active');
    });

    document.querySelector('.navigation-close').addEventListener('click', function(e) {
      e.preventDefault();
      document.querySelector('.navigation-mobile').classList.remove('is-active');
      document.querySelector('.navigation-mobile-overlay').classList.remove('is-active');
    });

    document.querySelector('.navigation-mobile-overlay').addEventListener('click', function(e) {
      e.preventDefault();
      document.querySelector('.navigation-mobile').classList.remove('is-active');
      document.querySelector('.navigation-mobile-overlay').classList.remove('is-active');
    });

    document.querySelectorAll('[data-scrollto]').forEach(function(el) {
      el.addEventListener('click', function(e) {
        e.preventDefault();
        document.querySelector('.navigation-mobile').classList.remove('is-active');
        document.querySelector('.navigation-mobile-overlay').classList.remove('is-active');
      });
    } );

    return true;

  };

  // Expose public methods & properties
  return {
    init: init,
  };

}().init());
